import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';

const routes: Routes = [


  { path: '', pathMatch: 'full', redirectTo: '/login' },
  {
    path: 'manage',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  // {
  //   path: 'manage/:uuid',
  //   loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  // },
  {
    path: "onboard",
    loadChildren: () => import('./onboard/onboard.module').then(m => m.OnboardModule)
  },
  {
    path: "login",
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: "login/:utmId",
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'createpin',
    loadChildren: () => import('./createpin/createpin.module').then(m => m.CreatepinModule)
  },
  {
    path: 'cardblocked',
    loadChildren: () => import('./card-blocked/card-blocked.module').then(m => m.CardBlockedModule)
  },
  {
    path: 'generalBlock',
    loadChildren: () => import('./generalblock/generalblock.module').then(m => m.GeneralblockModule)
  },
  {
    path: 'oBlock',
    loadChildren: () => import('./oblock/oblock.module').then(m => m.OblockModule)
  },
  {
    path: 'unexpected_error',
    loadChildren: () => import('./errorscreen/errorscreen.module').then(m => m.ErrorscreenModule)
  },
  {
    path: 'unexpected_error2',
    loadChildren: () => import('./errorscreen/errorscreen.module').then(m => m.ErrorscreenModule)
  },
  {
    path: 'manage/:uuid',
    loadChildren: () => import('./sharedbenefits/sharedbenefits.module').then(m => m.SharedbenefitsModule)
  },
  {
    path: 'manage/:uniqueId/:uuid',
    loadChildren: () => import('./flipkartreward/flipkartreward.module').then(m => m.FlipkartrewardModule)
  },
  {
    path: 'managev2/:uuid',
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'viewBenefitsV2',
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'rewards',
    loadChildren: () => import('./flipkartreward/flipkartreward.module').then(m => m.FlipkartrewardModule)
  },
  {
    path: 'viewBenefits',
    loadChildren: () => import('./sharedbenefits/sharedbenefits.module').then(m => m.SharedbenefitsModule)
  },
  {
    path: 'onboardV1',
    loadChildren: () => import('./onboardv1/onboardv1.module').then(m => m.Onboardv1Module)
  },
  {
    path: 'block/:uuid',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  // {
  //   path: 'successScreen',
  //   loadChildren: () => import('./successscreen/successscreen.module').then(m => m.SuccessscreenModule)
  // },
  {
    path: '**',
    loadChildren: () => import('./pagenotfound/pagenotfound.module').then(m => m.PagenotfoundModule)
  },

];
//, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' ,useHash: true }
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading, useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
